











import Vue from "vue";
import Footer from "./Footer.vue";
import SectionOne from "./sections/SectionOne.vue";
import SectionSecond from "./sections/SectionSecond.vue";
import SectionThird from "./sections/SectionThird.vue";
import SectionFourth from "./sections/SectionFourth.vue";
import SectionFifth from "./sections/SectionFifth.vue";

export default Vue.extend({
  components: {
    Footer,
    SectionOne,
    SectionSecond,
    SectionThird,
    SectionFourth,
    SectionFifth
  },
  data: () => ({})
});
